import icon_loading from '@/assets/elysia-loader.gif';

const LoadingPageComponent = () => {
  return (
    <div className="text-center">
      <img src={icon_loading} alt="loading" />
    </div>
  );
};

export default LoadingPageComponent;
